export default "<app-list-onboarding-templates class=\"flex-column v-100 h-100 flex-grow-1\"></app-list-onboarding-templates>\n";